<template lang="html">
    <div class="row">
        <div class="small-12 large-9 column">
            <template v-if="addresses.length">
            <VersandaufteilungOverlay
                :belegexemplar="belegexemplar"
                :isCheckout="isCheckout"
                :addresses="addresses"
                :auflage-zahl="auflageZahl"
                :productImageUrl="productImageUrl"
                :productName="productName"
                @closed="reloadBasket(...$event)"/>
            </template>
            <template v-else>
                <p>Loading...</p>
            </template>
        </div>
    </div>
</template>

<script>
import VersandaufteilungOverlay from "components/versandaufteilung/VersandaufteilungOverlay.vue";
import MysignGlobals from "mixins/mysignGlobals";
import {ShopItemRESTHelper} from "classes/api";

export default {
        components: { VersandaufteilungOverlay },
        mixins: { MysignGlobals },
        props: ['shopItemId', 'isCheckout', 'itemHasConfiguration'],
        data() {
            let globalConfig = window.FlyerlineConfig
            return {
                addresses: [], 
                auflageZahl: 0, 
                belegexemplar: "0",
                productImageUrl: globalConfig.productImageUrls[this.shopItemId],
                productName: globalConfig.productNames[this.shopItemId],
                globalConfig: globalConfig
            };
        },
        provide () {
            return {
                globalConfig: this.globalConfig
            }
        },
        methods: {
            reloadBasket(auflageLeft, oldAddresses) {
                if (auflageLeft != 0) {
                    this.addresses = oldAddresses
                } 
                else {
                    this.shopItemHelper.updateAddresses( {"addresses": this.addresses}, this.itemHasConfiguration ? 1 : this.auflageZahl ).then( () => {
                        $('body').trigger('invalidateBasketContent');
                    })
                }
            }
        },
        mounted () {
            this.shopItemHelper = new ShopItemRESTHelper( this.shopItemId )

            this.shopItemHelper.getSelectedAddresses()
            .then( response => {
                this.addresses = response.addresses
                this.auflageZahl = response.auflageZahl
                this.belegexemplar = response.belegexemplar
            })
        }
    };
</script>
